import React from 'react';
import CodeBlock from '../CodeBlock';
import type { CodeBlock as CodeBlockType } from '@/types/contentBlocks';

interface CodeBlockRendererProps {
  block: CodeBlockType;
  isDarkMode: boolean;
  isStreaming?: boolean;
}

export const CodeBlockRenderer: React.FC<CodeBlockRendererProps> = ({ block, isDarkMode, isStreaming = false }) => {
  return (
    <CodeBlock
      code={block.code}
      language={block.language}
      showLineNumbers={block.showLineNumbers !== false}
      isDarkMode={isDarkMode}
      isStreaming={isStreaming}
    />
  );
};
